"use client";

import type { PropsWithChildren } from "react";
import { useCallback, useState } from "react";

import { useIdleCallback } from "@/hooks/useIdleCallback";

export const DeferredMount = ({ children, timeoutMs = 1 }: PropsWithChildren<{ timeoutMs?: number }>) => {
  const [isReady, setIsReady] = useState(false);
  const onReady = useCallback(() => {
    setIsReady(true);
  }, []);

  useIdleCallback(onReady, timeoutMs);

  if (!isReady) {
    return null;
  }

  return children;
};
